export const cricketData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=cricket",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=cricket",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=cricket",
  },
  {
    title: "Players",
    path: "/players?sport=cricket",
  },
  {
    title: "Matches",
    path: "/matches?sport=cricket",
  },
  // {
  // 	title: "Commentary Options",
  // 	path: "/cricket/commentary-options",
  // },
  {
    title: "Officials",
    path: "/officials?sport=cricket",
  },
  {
    title: "Venues",
    path: "/venues?sport=cricket",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=cricket",
    // subNav: [
    //   {
    //     title: "Cricket Coach",
    //     path: "/cricket/cricket-coach",

    //   }
    // ],
  },
  // {
  //   title: "Ranking",
  //   path: "/cricket/ranking",
  // },
];

export const oddsMappingData = [
  {
    title: "Odds Subscriptions",
    path: "/odds-mapping/subscriptions",
  },
  {
    title: "Matches Mapping",
    path: "/odds-mapping/matches-mapping",
  },
  {
    title: "Manual Mapping",
    path: "/odds-mapping/create-manual-mapping",
  },
];

export const systemData = [
  {
    title: "Users",
    path: "/users",
  },
  {
    title: "Countries",
    path: "/countries",
  },
  {
    title: "Seasons",
    path: "/seasons",
  },
  // {
  //   title: "Promotions",
  //   path: "/promotions",
  // },
  // {
  //   title: "Group Promotions",
  //   path: "/group-promotions",
  // },
  {
    title: "Tv Channel",
    path: "/tv-channels",
  },
  {
    title: "Languages",
    path: "/languages",
  },
  {
    title: 'League Table Rules',
    path: '/league-table-rules'
  }
];

export const baseballData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=baseball",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=baseball",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=baseball",
  },
  {
    title: "Players",
    path: "/players?sport=baseball",
  },
  {
    title: "Matches",
    path: "/matches?sport=baseball",
  },
  {
    title: "Officials",
    path: "/officials?sport=baseball",
  },
  {
    title: "Venues",
    path: "/venues?sport=baseball",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=baseball",
  },
  // {
  //   title: "Match Mapping",
  //   path: "/match-mapping?sport=football",
  // },
  {
    title: "Provider Search",
    path: "/provider-search?sport=baseball",
  },
  // {
  //   title: "IPublisher Notification Mapping",
  //   path: "/ipublisher-notification-mapping?sport=baseball",
  // },
 
];

export const footbalData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=football",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=football",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=football",
  },
  {
    title: "Players",
    path: "/players?sport=football",
  },
  {
    title: "Matches",
    path: "/matches?sport=football",
  },
  {
    title: "Officials",
    path: "/officials?sport=football",
  },
  {
    title: "Venues",
    path: "/venues?sport=football",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=football",
  },
  {
    title: "Match Mapping",
    path: "/match-mapping?sport=football",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=football",
  },
  {
    title: "IPublisher Notification Mapping",
    path: "/ipublisher-notification-mapping?sport=football",
  },
  // {
  //   title: "TheSports",
  //   subNav: [
  //     {
  //       title: "Contest Groups",
  //       path: "/thesports-contest-groups-mapping?sport=football",
  //     },
  //     {
  //       title: "All Teams",
  //       path: "/thesports-teams?sport=football",
  //     },
  //     {
  //       title: "All Teams by ContestGroup ",
  //       path: "/thesports-teams-contest-groups?sport=football",
  //     },
  //     {
  //       title: "Players",
  //       path: "/thesports-players?sport=football",
  //     },
  //     {
  //       title: "Players by Team",
  //       path: "/thesports-players-by-team?sport=football",
  //     },
  //     {
  //       title: "Venues",
  //       path: "/thesports-venues-mapping?sport=football",
  //     },
  //     {
  //       title: "Coaches",
  //       path: "/thesports-coaches-mapping?sport=football",
  //     },
  //     {
  //       title: "Coaches by Team",
  //       path: "/thesports-coaches-by-team?sport=football",
  //     },
  //     {
  //       title: "Officials",
  //       path: "/thesports-officials-mapping?sport=football",
  //     },
  //   ],
  // },
];

export const golfData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=golf",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=golf"
  },
  {
    title: "Doubles",
    path: "/doubles?sport=golf",
  },
  {
    title: "Teams",
    path: "/teams?sport=golf",
  },
  {
    title: "Players",
    path: "/players?sport=golf",
  },
  // {
  //   title: "Player Group",
  //   path: "/player-group?sport=golf",
  // },
  {
		title: "Venues",
		path: "/venues?sport=golf",
	},
  {
    title: "Matches",
    path: "/matches?sport=golf",
  },
  {
    title: "Team Matches",
    path: "/team-matches?sport=golf",
  },
  {
		title: "Ryder Cup",
		path: "/ryder-cup?sport=golf",
	},
]

export const mmaData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=mma",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=mma"
  },
  {
    title: "Players",
    path: "/players?sport=mma",
  },
  // {
  //   title: "Player Group",
  //   path: "/player-group?sport=mma",
  // },
  {
		title: "Venues",
		path: "/venues?sport=mma",
	},
  {
    title: "Matches",
    path: "/matches?sport=mma",
  }
]

export const tennisData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=tennis",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=tennis",
  },
  {
    title: "Doubles",
    path: "/doubles?sport=tennis",
  },
  {
    title: "Teams",
    path: "/teams?sport=tennis",
  },
  {
    title: "Players",
    path: "/players?sport=tennis",
  },
  {
    title: "Matches",
    path: "/matches?sport=tennis",
  },
  {
    title: "Team Matches",
    path: "/team-matches?sport=tennis",
  },
  {
    title: "Officials",
    path: "/officials?sport=tennis",
  },
  {
    title: "Venues",
    path: "/venues?sport=tennis",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=tennis",
  },
  {
    title: "Rankings",
    path: "/rankings?sport=tennis",
  },
  {
    title: "Match Mapping",
    path: "/match-mapping?sport=tennis",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=tennis",
  },
];

export const tableTennisData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=table-tennis",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=table-tennis",
  },
  {
    title: "Doubles",
    path: "/doubles?sport=table-tennis",
  },
  {
    title: "Teams",
    path: "/teams?sport=table-tennis",
  },
  {
    title: "Players",
    path: "/players?sport=table-tennis",
  },
  {
    title: "Matches",
    path: "/matches?sport=table-tennis",
  },
  // {
  //   title: "Team Matches",
  //   path: "/team-matches?sport=table-tennis",
  // },
  {
    title: "Venues",
    path: "/venues?sport=table-tennis",
  },
  // {
  //   title: "Coaches",
  //   path: "/coaches?sport=table-tennis",
  // },
  // {
  //   title: "Rankings",
  //   path: "/rankings?sport=table-tennis",
  // },
  // {
  //   title: "Match Mapping",
  //   path: "/match-mapping?sport=table-tennis",
  // },
  // {
  //   title: "Provider Search",
  //   path: "/provider-search?sport=table-tennis",
  // },
];

export const basketballData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=basketball",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=basketball",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=basketball",
  },
  {
    title: "Players",
    path: "/players?sport=basketball",
  },
  {
    title: "Matches",
    path: "/matches?sport=basketball",
  },
  {
    title: "Match Mapping",
    path: "/match-mapping?sport=basketball",
  },
  {
    title: "Officials",
    path: "/officials?sport=basketball",
  },

  {
    title: "Venues",
    path: "/venues?sport=basketball",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=basketball",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=basketball",
  },
];

export const handballData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=handball",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=handball",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=handball",
  },
  {
    title: "Players",
    path: "/players?sport=handball",
  },
  {
    title: "Matches",
    path: "/matches?sport=handball",
  },
  {
    title: "Venues",
    path: "/venues?sport=handball",
  },
  {
    title: "Officials",
    path: "/officials?sport=handball",
  },
  {
    title: "Coaches",
    path: "/coaches?sport=handball",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=handball",
  },
];

export const hockeyData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=hockey",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=hockey",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=hockey",
  },
  {
    title: "Players",
    path: "/players?sport=hockey",
  },
  {
    title: "Matches",
    path: "/matches?sport=hockey",
  },
  {
    title: "Officials",
    path: "/officials?sport=hockey",
  },

  {
    title: "Venues",
    path: "/venues?sport=hockey",
  },
  {
    title: "Coach",
    path: "/coaches?sport=hockey",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=hockey",
  },
];

// export const feildHockeyData = [
//   {
//     title: "Tournaments",
//     path: "/field-hockey/tournament",
//   },
//   {
//     title: "Contest Groups",
//     path: "/field-hockey/contest",
//   },
//   {
//     title: "Competitors",
//     path: "/field-hockey/competitor",
//   },
//   {
//     title: "Matches",
//     path: "/field-hockey/match",
//   },
//   {
//     title: "Venues",
//     path: "/field-hockey/venue",
//   },
// ];

export const volleyballData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=volleyball",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=volleyball",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=volleyball",
  },
  {
    title: "Matches",
    path: "/matches?sport=volleyball",
  },
  {
    title: "Venues",
    path: "/venues?sport=volleyball",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=volleyball",
  },
];

// export const SnookerData = [
// 	{
// 		title: "Tournaments",
// 		path: "/snooker/tournament",
// 	},
// 	{
// 		title: "Contest Groups",
// 		path: "/snooker/contest",
// 	},
// 	{
// 		title: "Players",
// 		path: "/snooker/player",
// 	},
// 	{
// 		title: "Double",
// 		path: "/snooker/double",
// 	},
// 	{
// 		title: "Teams",
// 		path: "/snooker/team",
// 	},
// 	{
// 		title: "Matches",
// 		path: "/snooker/match",
// 	},
// 	{
// 		title: "Officials",
// 		path: "/snooker/official",
// 	},
// 	{
// 		title: "Venues",
// 		path: "/snooker/venue",
// 	},
// 	{
// 		title: "Rank",
// 		path: "/snooker/rank",
// 	}
// ];

export const americanFootballData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=american-football",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=american-football",
  },
  {
    title: "Competitors",
    path: "/competitors?sport=american-football",
  },
  {
    title: "Players",
    path: "/players?sport=american-football",
  },
  {
    title: "Matches",
    path: "/matches?sport=american-football",
  },
  {
    title: "Venues",
    path: "/venues?sport=american-football",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=american-football",
  },
];

export const horseRacingData = [
  {
    title: "Horses",
    path: "/horses?sport=horse-racing",
  },
  {
    title: "Jockeys",
    path: "/jockeys?sport=horse-racing",
  },
  {
    title: "Trainers",
    path: "/trainers?sport=horse-racing",
  },
  {
    title: "Owners",
    path: "/owners?sport=horse-racing",
  },
  {
    title: "Venues",
    path: "/venues?sport=horse-racing",
  },
  {
    title: "Meetings",
    path: "/meetings?sport=horse-racing",
  },
  {
    title: "Races",
    path: "/horse-races?sport=horse-racing",
  },
];

export const motorsportData = [
  {
    title: "Tournaments",
    path: "/tournaments?sport=motorsport",
  },
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=motorsport",
  },
  {
    title: "Teams",
    path: "/teams?sport=motorsport",
  },
  {
    title: "Drivers",
    path: "/drivers?sport=motorsport",
  },
  {
    title: "Races",
    path: "/races?sport=motorsport",
  },
  {
    title: "Venues",
    path: "/venues?sport=motorsport",
  },
  // {
  //   title: "Provider Search",
  //   path: "/provider-search?sport=american-football",
  // },
];

// export const floorBall = [
// 	{
// 		title: "Tournaments",
// 		path: "/floorball/tournament",
// 	},
// 	{
// 		title: "Contest Groups",
// 		path: "/floorball/contest",
// 	},
// 	{
// 		title: "Competitors",
// 		path: "/floorball/competitor",
// 	},
  
// 	{
// 		title: "Matches",
// 		path: "/floorball/match",
// 	},
// 	{
// 		title: "Venues",
// 		path: "/floorball/venue",
// 	},
// ];

export const rugbyUnionData = [
  {
		title: "Tournaments",
		path: "/tournaments?sport=rugby-union",
	},
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=rugby-union",
  },
  {
		title: "Competitors",
		path: "/competitors?sport=rugby-union",
	},
  {
    title: "Players",
    path: "/players?sport=rugby-union",
  },
  {
    title: "Matches",
    path: "/matches?sport=rugby-union",
  },
  {
    title: "Officials",
    path: "/officials?sport=rugby-union",
  },
  {
    title: "Venues",
    path: "/venues?sport=rugby-union",
  },

  {
    title: "Coach",
    path: "/coaches?sport=rugby-union",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=rugby-union",
  },
];

export const rugbyLeagueData = [
  {
		title: "Tournaments",
		path: "/tournaments?sport=rugby-league",
	},
  {
    title: "Contest Groups",
    path: "/contest-groups?sport=rugby-league",
  },
  {
		title: "Competitors",
		path: "/competitors?sport=rugby-league",
	},
  {
    title: "Players",
    path: "/players?sport=rugby-league",
  },
  {
    title: "Matches",
    path: "/matches?sport=rugby-league",
  },
  {
    title: "Officials",
    path: "/officials?sport=rugby-league",
  },
  {
    title: "Venues",
    path: "/venues?sport=rugby-league",
  },

  {
    title: "Coach",
    path: "/coaches?sport=rugby-league",
  },
  {
    title: "Provider Search",
    path: "/provider-search?sport=rugby-league",
  },
]